import { Component, Input } from '@angular/core';
import { getImageSrc } from '../../../core/images';

@Component({
  selector: 'app-home-page-card-header',
  styleUrls: ['home-page-card-header.component.scss'],
  templateUrl: './home-page-card-header.component.html',
})
export class HomePageCardHeaderComponent {
  getImageSrc = getImageSrc;

  @Input() title: string;
  @Input() imageUrl?: string;
}
